import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { style: {"padding":"20px"} }
const _hoisted_9 = { style: {"padding":"20px"} }
const _hoisted_10 = { style: {"padding":"20px"} }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { addAgent, allCardSecretAgent, disableUsers,addCommand,allAdminCommand,delAdminCommand } from '../../api'
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'cardamomAgent',
  setup(__props) {

  const search = reactive({
    key: "",
  })
   
  const loading = ref(false);
  
  const dataSource = ref([]);
  
  const selectedKeys = ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });

 

  
  const columns = ref([
    { title: "账号", key: "userName", align: "center" }, 
	{ title: "代理类型", key: "type", align: "center"  , customSlot: "type" },
	{ title: "会员天数", key: "days", align: "center" },
	{ title: "验证方式", key: "channelWitch", align: "center" , customSlot: "verifyStr"  },
	{ title: "验证天数", key: "withinDays", align: "center" },
	 
	 
    { title: "总卡密量", key: "totalCardSecrets", align: "center" },
    { title: "未激活", key: "inactivated", align: "center" },
    { title: "已激活", key: "activated", align: "center" }, 
    { title: "状态", key: "state", align: "center", customSlot: "state" }, 
    { title: "备注", key: "agentRemark", align: "center" },  
    { title: "注册时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center", width: "160px" }
  ]);
  
  
  const getAllAdminUser = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "key": search.key };
    allCardSecretAgent(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllAdminUser();

  const change = (page: any) => {
    getAllAdminUser();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  
  //禁用或者开启
  const changedelFlag = (row: any) => {
    var data = { "key": row.userId, "id": row.state };
    disableUsers(JSON.stringify(data)).then((res: any) => {
      if (res != "" && res.code == 0) {
        getAllAdminUser();
        layer.msg("操作成功", { time: 1000, icon: 1 });
      }
    })
  }
  
  //查询接口
  const searchUser = () => {
    page.current = 1;
    getAllAdminUser();
  }
  
  
  
  const agent = reactive({
    userId: "",
    userName: "",
    password: "", 
    agentRemark: "",
	type: 0,
	days: "",
	channelWitch: 0,
	withinDays: "",
	verifyArr:[], 
  })
  
  
  const updateUser = (row: any) => {
    agent.userId = row.userId;
    agent.userName = row.userName;
    agent.password = ""; 
    agent.type = row.type;  
	agent.days = row.days;  
	agent.channelWitch = row.channelWitch;  
	agent.verifyArr = row.verifyArr;  
	agent.withinDays = row.withinDays;   
	 agent.agentRemark = row.agentRemark;  
	
	
	
	
    isDisabled.value = true;
    visible11.value = !visible11.value;
  }
  
  const layFormRef11 = ref();
  
  const visible11 = ref(false);
  
  const isDisabled = ref(false);
  
  const changeVisible11 = () => {
    agent.userId = "";
    agent.userName = "";
    agent.password = ""; 
    agent.agentRemark = "";
	 agent.type =0;
	  agent.days ="";
	   agent.channelWitch =0;
	    agent.verifyArr =[];
	    agent.withinDays ="";
    isDisabled.value = false;
    visible11.value = !visible11.value;
  }
  
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        addAgent(JSON.stringify(agent)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllAdminUser();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false;
  
      }
    }
  ])


  const card = reactive({
    agentUserId: "",
    days: 0,
    type: 1, 
    num: 1,
    
  })

//查看
const ischeckCard = ref(false);
 const check=(row: any)=>{
    card.agentUserId=row.userId;
    ischeckCard.value=true;
    getAllAdminCommand();
 }

 const checkCardPage = reactive({ current: 1, limit: 10, total: 0 });
 const checkCardColumns = ref([ 
    { title: "口令", key: "key", align: "center" }, 
    { title: "天数", key: "days", align: "center" }, 
    { title: "状态", key: "state", align: "center", customSlot: "state" },
    { title: "类型", key: "type", align: "center", customSlot: "type" }, 
    { title: "激活时间", key: "activationTime", align: "center" },  
    { title: "添加时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);


const checkCardDataSource=  ref([]);


const  getAllAdminCommand=()=>{

    loading.value = true;
    var data = { "page": checkCardPage.current, "limit": checkCardPage.limit, "keyWord": card.agentUserId };
    allAdminCommand(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        checkCardDataSource.value = res.data;
        checkCardPage.total = res.count;
      } else {
        checkCardDataSource.value = [];
        checkCardPage.total = 0;
      }
    })

}

const changeCommand = (page: any) => {
    getAllAdminCommand();
  }

  
 //添加卡密
 const isaddCard = ref(false);


  const  addCard=()=>{ 
    isaddCard.value=true; 
  }


  const actionCard = ref([
    {
      text: "确认",
      callback: () => {
        addCommand(JSON.stringify(card)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllAdminCommand();
            isaddCard.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        isaddCard.value = false;
  
      }
    }
  ])

  //删除卡密
  const  delCard=(row: any)=>{
         
         var data={"id":row.id,"key":card.agentUserId};
 
         delAdminCommand(JSON.stringify(data)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllAdminCommand();
            isaddCard.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
  }

  
  
 
  
return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_switch = _resolveComponent("lay-switch")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_radio = _resolveComponent("lay-radio")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "代理账号",
                      prop: "username",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: search.key,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                          placeholder: "请输入账号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchUser
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_lay_button, {
                    size: "sm",
                    onClick: changeVisible11,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  state: _withCtx(({ row }) => [
                    _createVNode(_component_lay_switch, {
                      "model-value": row.state == 0 ? true : false,
                      onChange: ($event: any) => (changedelFlag(row)),
                      "onswitch-text": "正常",
                      "unswitch-text": "禁用"
                    }, null, 8, ["model-value", "onChange"])
                  ]),
                  type: _withCtx(({ row }) => [
                    (row.type==0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "推广代理"))
                      : (row.type==1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "福利代理"))
                        : (row.type==2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "不叠加代理"))
                          : _createCommentVNode("", true)
                  ]),
                  verifyStr: _withCtx(({ row }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.verifyArr, (verify) => {
                      return (_openBlock(), _createElementBlock("div", { key: verify }, [
                        (verify=='1')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_5, " ip "))
                          : (verify=='2')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, " ，注册 "))
                            : (verify=='3')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_7, " ，设备码 "))
                              : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (updateUser(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("修改")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (check(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查看")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['400px', '500px'],
      btn: action11.value,
      title: "添加/修改"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_lay_form, {
            model: agent,
            ref_key: "layFormRef11",
            ref: layFormRef11,
            pane: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "账户",
                prop: "userName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: agent.userName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((agent.userName) = $event)),
                    disabled: isDisabled.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "密码",
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: agent.password,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((agent.password) = $event)),
                    type: "password",
                    placeholder: "无需修改请置空"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "代理类型",
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: agent.type,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((agent.type) = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select_option, {
                        value: 0,
                        label: "推广代理"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 1,
                        label: "福利代理"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 2,
                        label: "不叠加代理"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (agent.type==1)
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 0,
                    label: "会员天数",
                    prop: "days"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: agent.days,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((agent.days) = $event)),
                        placeholder: "请输入会员天数"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (agent.type==1)
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 1,
                    label: "渠道开关",
                    prop: "channelWitch"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_radio, {
                        modelValue: agent.channelWitch,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((agent.channelWitch) = $event)),
                        name: "action",
                        value: 0,
                        label: "关闭"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_lay_radio, {
                        modelValue: agent.channelWitch,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((agent.channelWitch) = $event)),
                        name: "action",
                        value: 1,
                        label: "开启"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (agent.channelWitch==1)
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 2,
                    label: "验证天数",
                    prop: "withinDays",
                    tips: "验证多少天之内是新用户"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: agent.withinDays,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((agent.withinDays) = $event)),
                        placeholder: "请输入验证天数"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (agent.channelWitch==1)
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 3,
                    label: "验证方式",
                    prop: "verifyArr"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select, {
                        modelValue: agent.verifyArr,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((agent.verifyArr) = $event)),
                        "show-search": true,
                        multiple: true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_select_option, {
                            value: "1",
                            label: "ip"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: "2",
                            label: "账号"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: "3",
                            label: "设备码"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_lay_form_item, {
                label: "备注",
                prop: "agentRemark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入备注",
                    modelValue: agent.agentRemark,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((agent.agentRemark) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"]),
    _createVNode(_component_lay_layer, {
      modelValue: isaddCard.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((isaddCard).value = $event)),
      shade: false,
      area: ['400px', '430px'],
      btn: actionCard.value,
      title: "添加卡密"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_lay_form, {
            model: card,
            ref_key: "layFormRef11",
            ref: layFormRef11,
            pane: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "有效期",
                prop: "type"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: card.type,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((card.type) = $event)),
                    placeholder: "请选择有效期"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select_option, {
                        value: 1,
                        label: "有效期"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 2,
                        label: "永久"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (card.type==1)
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 0,
                    label: "天数",
                    prop: "days"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: card.days,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((card.days) = $event)),
                        placeholder: "请输入会员天数"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_lay_form_item, {
                label: "卡密数量",
                prop: "num"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: card.num,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((card.num) = $event)),
                    placeholder: "请输生成卡密的数量"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"]),
    _createVNode(_component_lay_layer, {
      modelValue: ischeckCard.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((ischeckCard).value = $event)),
      shade: false,
      area: ['850px', '630px'],
      title: "查看卡密"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_lay_table, {
            page: checkCardPage,
            height: '100%',
            columns: checkCardColumns.value,
            loading: loading.value,
            "data-source": checkCardDataSource.value,
            size: "sm",
            "selected-keys": selectedKeys.value,
            "onUpdate:selectedKeys": _cache[17] || (_cache[17] = ($event: any) => ((selectedKeys).value = $event)),
            onChange: changeCommand,
            onSortChange: sortChange
          }, {
            toolbar: _withCtx(() => [
              _createVNode(_component_lay_button, {
                size: "sm",
                type: "primary",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (addCard()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加卡密")
                ]),
                _: 1
              })
            ]),
            type: _withCtx(({ row }) => [
              (row.type==1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "效期"))
                : (row.type==2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "永久"))
                  : _createCommentVNode("", true)
            ]),
            state: _withCtx(({ row }) => [
              (row.state==1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "未激活"))
                : (row.state==2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "已激活"))
                  : _createCommentVNode("", true)
            ]),
            operator: _withCtx(({ row }) => [
              _createVNode(_component_lay_button, {
                size: "xs",
                type: "danger",
                onClick: ($event: any) => (delCard(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})